
import { getValue } from '@softline/core';
import { QueryBuilder, Query } from '../../query/query.builder';
import { GridSSRMDataSource } from '../types/grid-data-source';
import { QueryRepository } from '../../query/repositories/query.repository';

export abstract class GridSSRMService<T extends object> implements GridSSRMDataSource<T> {
  type: 'ssrm' = 'ssrm';
  protected abstract repository: QueryRepository<T>

  async load(query: Query): Promise<{data: Partial<T[]>, pivotFields?: string[]}> {
    return await this.repository.load(query);
  }
}
